module.exports = __webpack_public_path__ + "img/acon.2025b69.png";